export const isDevelopment = process.env.NODE_ENV === 'development';
export const useMockData = process.env.REACT_APP_USE_MOCK_DATA === 'true';
export const isLocalStack = process.env.REACT_APP_USE_LOCALSTACK === 'true';
export const endpoint = isLocalStack ? 'http://localhost:4566' : undefined;
